import PaywallPopover from "components/paywall/PaywallPopover";
import Button from "components/ui/button/Button";
import { AI_REPORT_CONFIG, useVariableValue } from "lib/featureFlags";
import { useAccountBriefingRequest } from "lib/hooks/api/buyer/useAccountBriefingRequest";
import { useCurrentUser } from "lib/hooks/api/users/useCurrentUser";
import { useSubscription } from "lib/hooks/subscription";
import { EventNames, useTracking } from "lib/tracking";
import { ManagedResearchRequestType } from "lib/types/graphQLEnums";
import { BuyerDetails, BuyerSummary } from "lib/types/models";

type Props = {
  buyer: BuyerSummary | BuyerDetails;
  // TODO: move to reading from tracking context (context as in react context)
  contextName: string;
  className?: string;
  type: "primary" | "secondary";
};

export default function AccountBriefingBtn({
  buyer,
  contextName,
  type,
}: Props): JSX.Element | null {
  const { mutate: requestAccountBriefing, isLoading } = useAccountBriefingRequest();
  const { logEvent } = useTracking();
  const aiReportConfigEnabled = useVariableValue(AI_REPORT_CONFIG, false);
  const { data: currentUser } = useCurrentUser();

  const subscription = useSubscription();

  const onClick = () => {
    if (!currentUser || !subscription.hasDataTypes("BUYERS")) {
      return;
    }

    logEvent(EventNames.accountBriefingBtnClicked, {
      "Context source": contextName,
      "Current user": {
        email: currentUser.email,
        guid: currentUser.guid,
        "company name": currentUser.company.name,
        "company id": currentUser.company.id,
      },
      "Current url": window.location.href,
    });
    requestAccountBriefing({
      input: {
        buyerGuid: buyer.guid,
        requestType: ManagedResearchRequestType.Level_1Briefing,
      },
    });
  };

  if (!currentUser?.hasAccountBriefingPermission) {
    return null;
  }

  return (
    <PaywallPopover featureType="BUYERS" contextSource={contextName}>
      <Button
        onClick={onClick}
        loading={isLoading}
        buttonType={type}
        icon={aiReportConfigEnabled ? "magicWand" : undefined}
      >
        {type === "primary" ? "Create briefing" : "Get account briefing"}
      </Button>
    </PaywallPopover>
  );
}
